import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@material-ui/core";
import { PropertyTaskCard } from "./UI";
import { GetProjectTasks, GetTaskConfigById } from "../../../../../../Services";
import {
  ContactTaskCardSkeleton,
  CustomPagination,
  NoDataFound,
} from "../../../../../../Components";

//  styles
import useStyles from "./styles";

function Task({ propretyId }) {
  const styles = useStyles();
  const [pagination, setPagination] = useState({
    pageIndex: 1,
    pageSize: 25,
  });
  const [inputValue, setInputValue] = useState(pagination.pageIndex);
  const [tasks, setTasks] = useState({
    result: [],
    totalCount: 0,
  });
  const [isLoadingTask, setIsLoadingTask] = useState(true);
  const [isLoadingApprovalStatus, setIsLoadingApprovalStatus] = useState(true);
  const [approvalStatuses, setApprovalStatuses] = useState({});

  const getProjectTasks = useCallback(async () => {
    setIsLoadingTask(true);

    const body = {
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      relatedToLeadId: null,
      relatedToUnitId: null,
      relatedToContactId: null,
      relatedToPropertyId: propretyId,
    };

    const res = await GetProjectTasks(body);
    if (!(res && res.status && res.status !== 200)) {
      setTasks({
        result: res?.result,
        totalCount: res?.totalCount,
      });
    } else {
      setTasks({
        result: [],
        totalCount: 0,
      });
    }
    setIsLoadingTask(false);
  });

  const taskConfiguration = useCallback(async () => {
    setIsLoadingApprovalStatus(true);
    const statusMap = {};

    for (const taskItem of tasks?.result || []) {
      const res = await GetTaskConfigById(taskItem?.taskConfigId);
      if (!(res && res.status && res.status !== 200)) {
        statusMap[taskItem?.taskConfigId] = res?.isTaskRequireApproval;
      }
    }

    setApprovalStatuses(statusMap);
    setIsLoadingApprovalStatus(false);
  }, [tasks?.result]);

  useEffect(() => {
    getProjectTasks();
  }, [pagination]);

  useEffect(() => {
    if (tasks?.result?.length > 0) {
      taskConfiguration();
    }
  }, [tasks?.result]);

  return (
    <Box className={styles.wrapperTaskTab}>
      <Box className={styles.wrapperTaskCards}>
        {isLoadingTask && isLoadingApprovalStatus ? (
          <ContactTaskCardSkeleton NumberSkeletonCard={8} />
        ) : tasks?.result?.length > 0 ? (
          tasks?.result?.map((taskItem, index) => (
            <PropertyTaskCard
              key={index}
              taskDetails={taskItem}
              isNeedApproval={approvalStatuses[taskItem?.taskConfigId]}
            />
          ))
        ) : (
          <NoDataFound title={"task"} />
        )}
      </Box>
      {tasks?.result?.length > 0 && tasks.totalCount > 0 && (
        <CustomPagination
          totalItems={tasks?.totalCount}
          itemsPerPage={pagination?.pageSize}
          currentPage={pagination?.pageIndex}
          inputValue={inputValue}
          setInputValue={setInputValue}
          onPageChange={(page) =>
            setPagination((prev) => ({ ...prev, pageIndex: page }))
          }
          onItemsPerPageChange={(items) =>
            setPagination((prev) => ({ ...prev, pageSize: items }))
          }
          isLoading={isLoadingTask}
        />
      )}
    </Box>
  );
}

export default Task;
